import Button from "../Button/Button";

function ModaleAnnulla(props) {


    return (
        <div style={{height:"200px"}}>
            <span style={{display:"flex",justifyContent:"center",textAlign:"center",marginTop:"1rem"}}>{props.testo || "Attenzione! Stai per uscire dall’inserimento della candidatura. Le informazioni inserite non saranno salvate."}</span>
            <div className={"row"} style={{bottom:"0",position:"absolute",marginBottom:"2rem",marginLeft:"110px"}}>
                <div className={"col-6"}>
                    <Button
                        id={props.idAnnulla || "buttonAnnulla"}
                        typeButton={"White"}
                        text={"Annulla"}
                        style={{height:"50px",width:"200px"}}
                        dataDismiss="modal"
                    />
                </div>
                <div className={"col-6"}>
                    <Button
                        id={props.idConferma || "buttonConferma"}
                        typeButton={"Blue"}
                        onClick={props.onClick}
                        text={props.testoConferma || "Conferma"}
                        style={{height:"50px",width:"200px"}}
                        dataDismiss="modal"
                    />
                </div>
            </div>

        </div>)


}

export default ModaleAnnulla
